import { render, staticRenderFns } from "./DiscussSecond.vue?vue&type=template&id=d905dc48&"
import script from "./DiscussSecond.vue?vue&type=script&lang=js&"
export * from "./DiscussSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports